import { ViteReactSSG } from "vite-react-ssg";
import type { RouteRecord } from "vite-react-ssg";
import "@/styles/tokens.css";
import { Layout } from "@/components/Layout";
import { DEMO_DOMAINS } from "@/content/demos";
import { USE_CASES } from "@/content/usecases";

// React Router v7's `lazy` spreads the returned object onto the route.
// Since our pages use `export default`, we map default → Component so
// that React Router recognises it.  Plain `() => import("@/pages/Home")`
// would spread `{ default: Cmp }` which RR7 ignores.
export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        lazy: async () => {
          const { default: Component } = await import("@/pages/Home");
          return { Component };
        },
      },
      {
        path: "features",
        lazy: async () => {
          const { default: Component } = await import("@/pages/Features");
          return { Component };
        },
      },
      {
        path: "demos",
        lazy: async () => {
          const { default: Component } = await import("@/pages/Demos");
          return { Component };
        },
      },
      {
        path: "demos/:category",
        lazy: async () => {
          const { default: Component } = await import("@/pages/DemoCategory");
          return { Component };
        },
      },
      {
        path: "ai",
        lazy: async () => {
          const { default: Component } = await import("@/pages/Ai");
          return { Component };
        },
      },
      {
        path: "enterprise",
        lazy: async () => {
          const { default: Component } = await import("@/pages/Enterprise");
          return { Component };
        },
      },
      {
        path: "book-demo",
        lazy: async () => {
          const { default: Component } = await import("@/pages/BookDemo");
          return { Component };
        },
      },
      {
        path: "use-cases",
        lazy: async () => {
          const { default: Component } = await import("@/pages/UseCases");
          return { Component };
        },
      },
      {
        path: "use-cases/:slug",
        lazy: async () => {
          const { default: Component } = await import("@/pages/UseCaseDetail");
          return { Component };
        },
      },
    ],
  },
];

export const createRoot = ViteReactSSG({ routes });

// vite-react-ssg reads `includedRoutes` from the server entry at build time to
// decide which paths to prerender. Expand the dynamic `demos/:category` route
// into the 11 concrete category paths (the raw param route is dropped by the
// default `:`-filter).
export function includedRoutes(paths: string[]): string[] {
  return [
    ...paths.filter((p) => !p.includes(":")),
    ...DEMO_DOMAINS.map((d) => `/demos/${d.slug}`),
    ...USE_CASES.map((u) => `/use-cases/${u.slug}`),
  ];
}
